export const blockIconsImageBrush = (
	<span className='material-symbols-outlined'>brush</span>
);
